import fetch from "cross-fetch";
import { CIRCLES_API } from "../../config";
import { shouldFetchCircleDetails } from "./selectors.js";
import * as ActionCreators from "./creators";

export function fetchCircle(id) {
  return function(dispatch, getState) {
    if (!shouldFetchCircleDetails(getState(), id)) {
      return Promise.resolve();
    }
    dispatch(ActionCreators.fetchingCircleDetails(id));
    let url = `${CIRCLES_API}/circle/${id}`;

    return fetch(url)
      .then(
        response => response.json(),
        error => {
          dispatch(ActionCreators.errorFetchingCircleDetails(error, id));
        }
      )
      .then(response => {
        if(!response) return null;
        
        if ("message" in response || "errors" in response) {
        } else {
          dispatch(ActionCreators.fetchedCircleDetails(response, id));
        }
      });
  };
}
